module.exports = __webpack_public_path__ + "static/img/e8.0a04275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/e8.png
// module id = xPpJ
// module chunks = 1